import type { BundledMap } from '@yimoka/i18n';

import { registerLocaleResources } from '@/locales/register';

import baseResources from './resources/base.json';

export type AdminLocaleScope = 'announcement' | 'assets' | 'content' | 'display' | 'education' | 'members' | 'quality' | 'relation' | 'roles' | 'teacherStudio' | 'tenant';

const resourceLoaders: Record<AdminLocaleScope, () => Promise<{ default: BundledMap }>> = {
  announcement: () => import('./resources/announcement.json'),
  assets: () => import('./resources/assets.json'),
  content: () => import('./resources/content.json'),
  display: () => import('./resources/display.json'),
  education: () => import('./resources/education.json'),
  members: () => import('./resources/members.json'),
  quality: () => import('./resources/quality.json'),
  relation: () => import('./resources/relation.json'),
  roles: () => import('./resources/roles.json'),
  teacherStudio: () => import('./resources/teacher-studio.json'),
  tenant: () => import('./resources/tenant.json'),
};

const loadingScopes = new Map<AdminLocaleScope, Promise<void>>();

/** 管理台壳层只注入通用、布局、权限和路由文案。 */
export function registerAdminBaseLocales(): void {
  registerLocaleResources(baseResources as BundledMap);
}

/** 页面分包加载时同步加载所属语言资源，同一 scope 在会话内只注册一次。 */
export function loadAdminPageLocales(scope: AdminLocaleScope): Promise<void> {
  const cached = loadingScopes.get(scope);
  if (cached) return cached;

  const pending = resourceLoaders[scope]().then((module) => {
    registerLocaleResources(module.default);
  })
    .catch((error: unknown) => {
      loadingScopes.delete(scope);
      throw error;
    });
  loadingScopes.set(scope, pending);
  return pending;
}
